import { getMainSiteUrl, MAIN_SITE_URL, resolveSiteUrl } from "./appConfig";

export const SITE = {
  name: "CAF Sports",
  url: resolveSiteUrl(),
  mainUrl: MAIN_SITE_URL,
  /** Use in href — dev-aware (localhost:3001 when testing landing locally). */
  getMainSiteUrl,
  portfolioUrl: "https://eslam-emam-portfolio.netlify.app/",
  facebookUrl: "https://www.facebook.com/ConsultantArabFlooring.CAFsports",
  whatsappNumber: "+201141227755",
  phones: {
    egyptPrimary: "+201141227755",
    egyptSecondary: "+20126484032",
    uae: "+971543575745",
  },
  emails: {
    info: "info@caf-sports.com",
    uae: "sales_uae@caf-sports.com",
    egypt: "sales_egy@caf-sports.com",
  },
  maps: {
    uae: "https://www.google.com/maps/place/United+Arab+Emirates/@24.3361314,51.3062024,7z/data=!3m1!4b1!4m6!3m5!1s0x3e5e48dfb1ab12bd:0x33d32f56c0080aa7!8m2!3d23.424076!4d53.847818!16zL20vMGoxejg?entry=ttu",
    egypt: "https://maps.app.goo.gl/9TjhPheEsVWgsdsB7",
  },
};

export const SOCIAL_LINKS = [
  { id: "facebook", href: SITE.facebookUrl, external: true },
  {
    id: "whatsapp",
    href: `https://wa.me/${SITE.whatsappNumber.replace(/\D/g, "")}`,
    external: true,
  },
  { id: "phone", href: `tel:${SITE.phones.egyptSecondary}`, external: false },
];
